export enum Role {
  WORKER = 'WORKER',
  AGENCY = 'AGENCY',
  ADMIN = 'ADMIN',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  BANNED = 'BANNED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum JobType {
  SHIFT = 'SHIFT',
  TASK = 'TASK',
  ONGOING = 'ONGOING',
}

export enum JobCategory {
  CHATTER = 'CHATTER',
  VA = 'VA',
  OTHER = 'OTHER',
}

export enum JobStatus {
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  PAUSED = 'PAUSED',
  CLOSED = 'CLOSED',
  FILLED = 'FILLED',
  EXPIRED = 'EXPIRED',
}

export enum ApplicationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN',
}

export enum ContractStatus {
  PENDING_ESCROW = 'PENDING_ESCROW',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  DISPUTED = 'DISPUTED',
}

export enum PaymentType {
  ESCROW_DEPOSIT = 'ESCROW_DEPOSIT',
  ESCROW_RELEASE = 'ESCROW_RELEASE',
  FEE = 'FEE',
  REFUND = 'REFUND',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  CONFIRMING = 'CONFIRMING',
  CONFIRMED = 'CONFIRMED',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
}

export enum EscrowStatus {
  AWAITING_DEPOSIT = 'AWAITING_DEPOSIT',
  FUNDED = 'FUNDED',
  PARTIALLY_RELEASED = 'PARTIALLY_RELEASED',
  RELEASED = 'RELEASED',
  REFUNDED = 'REFUNDED',
  DISPUTED = 'DISPUTED',
}

export enum KYCStatus {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum ConversationType {
  JOB = 'JOB',
  SUPPORT = 'SUPPORT',
}

export enum Chain {
  ETHEREUM = 'ETHEREUM',
  POLYGON = 'POLYGON',
  BASE = 'BASE',
  SOLANA = 'SOLANA',
}

export enum Currency {
  USDT = 'USDT',
  USDC = 'USDC',
}

export enum NotificationType {
  JOB_NEW_MATCH = 'JOB_NEW_MATCH',
  APPLICATION_RECEIVED = 'APPLICATION_RECEIVED',
  APPLICATION_ACCEPTED = 'APPLICATION_ACCEPTED',
  APPLICATION_REJECTED = 'APPLICATION_REJECTED',
  CONTRACT_CREATED = 'CONTRACT_CREATED',
  CONTRACT_COMPLETED = 'CONTRACT_COMPLETED',
  ESCROW_FUNDED = 'ESCROW_FUNDED',
  ESCROW_RELEASED = 'ESCROW_RELEASED',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  MESSAGE_NEW = 'MESSAGE_NEW',
  KYC_STATUS_CHANGE = 'KYC_STATUS_CHANGE',
  SYSTEM_ALERT = 'SYSTEM_ALERT',
}
